(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    // 「開く」ボタン処理
    document.querySelectorAll(".js-open-left").forEach((button) => {
      button.addEventListener("click", function () {
        const targetClass = this.getAttribute("data-open-left-target");
        if (!targetClass) return;

        // 対象に -active クラスを追加
        document.querySelectorAll(`.${targetClass}`).forEach((el) => {
          el.classList.add("-active");
        });
      });
    });

    // 「閉じる」ボタン処理
    document.querySelectorAll(".js-close-right").forEach((button) => {
      button.addEventListener("click", function () {
        const targetClass = this.getAttribute("data-open-left-target");
        if (!targetClass) return;

        // 対象から -active クラスを削除
        document.querySelectorAll(`.${targetClass}`).forEach((el) => {
          el.classList.remove("-active");
        });
      });
    });
  });
})();
